import React from 'react'

import { styled } from '@mui/material/styles'

const PREFIX = 'View'

const classes = {
  root: `${PREFIX}-root`
}

const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {
    maxWidth: '1400px',
    display: 'flex',
    margin: '0 auto',
    width: '100%'
  }
}))

const View: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <Root className={classes.root}>{children}</Root>
}

export default View
